import { withAbsolutePath } from '@pressreader/routing';

function makeAbsolutePath(relativePath: string) {
    return `${window.location.origin}${withAbsolutePath(relativePath)}`;
}

export { makeAbsolutePath };
